import type {User} from 'nutshell-core/users/users-types';

import type {ContactPageFragment as Contact} from 'nutshell-graphql-types';

import {CoreEntitySidebar} from '../../../core-entity/layout/core-entity-sidebar';
import {getWidgetComponents} from '../../../core-entity/util/widget-components';

type Props = {
    contact: Contact;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    hasFullHeightSidebar?: boolean;
};

export function ContactSidebar(props: Props) {
    const widgets = getWidgetComponents({
        mode: 'contact',
        entityId: props.contact.id,
        widgets: props.contact.sidebarWidgets ?? [],
        user: props.user,
    });

    return (
        <CoreEntitySidebar
            hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            {widgets}
        </CoreEntitySidebar>
    );
}
